import { CoKitchenType } from 'models/cokitchen.model';
import { LogisticConfigType } from 'models/polygon.model';
import { createContext, useContext } from 'react';

export type DashboardContextType = {
  activeCokitchen: CoKitchenType;
  setActiveCokitchen: (cokitchen: CoKitchenType) => void;
  loading: boolean;
  loadingExternalRiderCount: boolean;
  setLoading: (loading: boolean) => void;
  shouldRefetchBrands: number;
  setShouldRefetchBrands: (seed: number) => void;
  checkReactivationTime: number;
  setCheckReactivationTime: (time: number) => void;
  riderCount: { count: string };
  selectedPolygonLogisticsConfig?: {
    polygonId: string;
    logisticsConfig: LogisticConfigType;
    bulkUpdate: boolean;
  };
  setSelectedPolygonLogisticsConfig: (data: {
    polygonId: string;
    logisticsConfig: LogisticConfigType;
    bulkUpdate: boolean;
  }) => void;
};

export const DashboardContext = createContext({} as DashboardContextType);

const useDashboardContext = () => {
  const context = useContext(DashboardContext);
  return context;
};

export default useDashboardContext;
